import { t } from "../i18n"
import { Controller } from "@hotwired/stimulus"

// Handles checkbox selection for tag delivery order creation form
export default class extends Controller {
  static targets = ["checkbox", "masterCheckbox", "count"]

  connect() {
    this.updateCount()
  }

  toggleAll() {
    const checked = this.masterCheckboxTarget.checked
    this.checkboxTargets.forEach(cb => { cb.checked = checked })
    this.updateCount()
  }

  selectAll() {
    this.checkboxTargets.forEach(cb => { cb.checked = true })
    if (this.hasMasterCheckboxTarget) this.masterCheckboxTarget.checked = true
    this.updateCount()
  }

  deselectAll() {
    this.checkboxTargets.forEach(cb => { cb.checked = false })
    if (this.hasMasterCheckboxTarget) this.masterCheckboxTarget.checked = false
    this.updateCount()
  }

  updateCount() {
    const selected = this.checkboxTargets.filter(cb => cb.checked).length
    if (this.hasCountTarget) {
      this.countTarget.textContent = t("javascript.controllers.tag_delivery_selection_controller.selected_count", { count: selected })
    }
  }
}
